export interface Status {
  id: string;
  name: string;
}
